import React from "react"
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { cleanSuccessDeleted, remove } from "../../redux/reducer/authoritiesRed";

export default function RmAuthority({values}){
    const dispatch = useDispatch()
    const successDeleted = useSelector(state => state.authorities.successDeleted)
    const handleDelete = () => {
        const data = { id:values.id}
        Swal.fire({
            title:'Desea eliminar este cargo?',
            text:values.position,
            icon:'question',
            confirmButtonText:'Eliminar',
            showCancelButton:true
        }).then(value=>{
            value.isConfirmed && dispatch(remove(data))
        })
    }
    React.useEffect(()=>{
        if(successDeleted){
            Swal.fire({
                title:'Cargo eliminado con éxito',
                icon:'success',
                confirmButtonText:'Ok'
            }).then(value=>{
                if(value){
                    dispatch(cleanSuccessDeleted())
                    window.location.reload()
                }
            })
        }
    },[successDeleted])
    
    return (
        <>
            <span onClick={()=>handleDelete()} class=" material-symbols-outlined">
                delete
            </span>
        </>
    )
}